import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonDataSharingService } from '../../services/common-data-sharing.service';
import { fileDirectories } from 'src/app/utils/view-settings';

@Component({
  selector: 'app-assign-business-popup',
  templateUrl: './assign-business-popup.component.html',
  styleUrl: './assign-business-popup.component.scss'
})
export class AssignBusinessPopupComponent implements OnInit {
  assignedBusinessesList: any = [];
  s3Directories: any = fileDirectories;

  constructor(private _activeModal: NgbActiveModal, private _commonDataService: CommonDataSharingService) {
    this._commonDataService.getAssignedBusinessesList().subscribe({
      next: (res: any) => {
        this.assignedBusinessesList = res
      }
    });
  }

  ngOnInit(): void { }

  onClose(selectedFilters?: any): void {
    this._activeModal.close(selectedFilters);
  }
}
